import arrowLinks from './components/arrow-links';
import header from './components/header';
import { load as loadPageData } from './components/page-data';
import pageNavigation from './components/page-navigation';
import quoteCarousels from './components/quote-carousels';
import cardCarousels from './components/card-carousels';
import search from './components/search';
import skipMenu from './components/skip-menu';
import smoothScrollingAnchors from './components/smooth-scrolling-anchors';
import tabGroups from './components/tab-groups';
import popups from './components/popups';
import accordions from './components/accordions';
import cards from './components/cards';
import revealer from './components/revealer';
import tracking from './components/tracking';
import valuesGrid from './components/values-grid';
import links from './components/links';
import * as utils from './utils';

log.setDefaultLevel('info');

window.utils = utils;

window.equalizeCards = cards.equalize;

window.initializeArrowLinks = arrowLinks.initialize;

window.pageData = loadPageData();

$(function() {

    header.initialize();
    arrowLinks.initialize();
    pageNavigation.initialize();
    quoteCarousels.initialize();
    cardCarousels.initialize();
    search.initialize();
    skipMenu.initialize();
    smoothScrollingAnchors.initialize();
    tabGroups.initialize();
    popups.initialize();
    accordions.initialize();
    cards.initialize();
    revealer.initialize();
    tracking.initialize();
    valuesGrid.initialize();
    links.initialize();
});

